import pricingPage from './pricing.vue';
import pricingDeskView from './desk-view/pricing-desk-view.vue';
import pricingImpactView from './impact-view/pricing-impact-view.vue';
import competitorPriceIgnore from './competitor-price-ignore/competitor-price-ignore.vue';
import { pricing as pricingPageIndex } from '@enums/page-index';

import { enablePricingImpactView, enableCompetitorPriceIgnore } from '@enums/feature-flags';

const routes = [
  {
    path: '/pricing',
    name: 'pricing',
    id: 'pricing',
    component: pricingPage,
    linkText: 'linkText.pricing',
    index: pricingPageIndex,
    children: [
      {
        path: 'desk-view/workpackage/:workpackageId',
        name: 'pricingDeskView',
        id: 'pricingDeskView',
        component: pricingDeskView,
        linkText: 'linkText.deskView',
        index: 0,
        meta: {
          selectedWorkpackageRequired: true,
          title: 'tabText.deskView',
        },
      },
      {
        path: 'impact-view/workpackage/:workpackageId',
        name: 'pricingImpactView',
        id: 'pricingImpactView',
        component: pricingImpactView,
        linkText: 'linkText.impactView',
        index: 1,
        meta: {
          selectedWorkpackageRequired: true,
          title: 'tabText.impactView',
          featureFlag: enablePricingImpactView,
          // when impact-view is disabled, redirect to desk-view instead of home
          featureFlagRedirectName: 'pricingDeskView',
        },
      },
      {
        path: 'competitor-price-ignore/workpackage/:workpackageId',
        name: 'competitorPriceIgnore',
        id: 'competitorPriceIgnore',
        component: competitorPriceIgnore,
        linkText: 'linkText.competitorPriceIgnore',
        index: 2,
        meta: {
          selectedWorkpackageRequired: true,
          title: 'tabText.competitorPriceIgnore',
          featureFlag: enableCompetitorPriceIgnore,
          featureFlagRedirectName: 'pricingDeskView',
        },
      },
    ],
  },
];

export default routes;
